import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/WaterwayCabinets/Get`, payload),
    GetExport: (payload) => Repository.post(`/api/WaterwayCabinets/GetExport`, payload),
    GetActive: (payload) => Repository.post(`/api/WaterwayCabinets/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/WaterwayCabinets/GetById`, payload),
    Add: (payload) => Repository.post(`/api/WaterwayCabinets/Add`, payload),
    Export: (payload) => Repository.post(`/api/WaterwayCabinets/Export`, payload),
    Edit: (payload) => Repository.post(`/api/WaterwayCabinets/Edit`, payload),
    Deploy: (payload) => Repository.post(`/api/WaterwayCabinets/Deploy`, payload),
    Delete: (payload) => Repository.post(`/api/WaterwayCabinets/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/WaterwayCabinets/Delete`, payload),
}
